import { observer } from "mobx-react";
import React from "react";
import styled, { css } from "styled-components";

import Style from "@client/utils/Style";

import errorHollowImage from "./images/error-hollow.svg";
import errorImage from "./images/error.svg";
import pendingImage from "./images/pending.svg";
import progressImage from "./images/progress";
import progressWithBackgroundImage from "./images/progress-background.svg";
import successHollowImage from "./images/success-hollow.svg";
import successImage from "./images/success.svg";
import warningImage from "./images/warning.svg";

type Props = {
  status: string;
  useBackground?: boolean;
  hollow?: boolean;
  secondary?: boolean;
};

const getRunningImageUrl = (props: Props) => {
  const smallCircleColor = props.secondary
    ? Style.palette.grayscale[0]
    : Style.palette.primary;

  if (props.useBackground) {
    return css`url('${progressWithBackgroundImage}')`;
  }

  return css`url('data:image/svg+xml;utf8,${encodeURIComponent(
    progressImage(Style.palette.grayscale[3], smallCircleColor),
  )}')`;
};

const completedBackground = (hollow: boolean) =>
  `url('${hollow ? successHollowImage : successImage}')`;

const statuses = (
  props: any,
): {
  [key: string]: any;
} => {
  return {
    COMPLETED: css`
      background-image: ${completedBackground(props.hollow)};
    `,
    RUNNING: css`
      background-image: ${getRunningImageUrl(props)};
      ${Style.animations.rotation}
    `,
    ERROR: css`
      background-image: url("${props.hollow ? errorHollowImage : errorImage}");
    `,
    WARNING: css`
      background-image: url("${warningImage}");
    `,
    CANCELED: css`
      background-image: url("${warningImage}");
    `,
    PENDING: css`
      background-image: url("${pendingImage}");
    `,
  };
};

const Wrapper = styled.div<{ status: string }>`
  min-width: 16px;
  max-width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center;
  ${props => statuses(props)[props.status]}
`;

@observer
class StatusIcon extends React.Component<Props> {
  render() {
    return <Wrapper {...this.props} />;
  }
}

export default StatusIcon;
